import { Injectable } from '@angular/core';
import { StorageService } from './storage.service';


@Injectable({
  providedIn: 'root'
})
export class DebugService {

  isDebugMode:boolean = false;

  constructor(
    private storageService: StorageService
  ) {
    let debugInSession  =  this.storageService.loadSessionStorage('debugMode');
    if (parseInt(debugInSession) > 0) {
      this.isDebugMode = true;
    }
    
  }

  setDebugMode(value:number) {
    this.storageService.saveSessionStorage('debugMode', value);
    if (value > 0) {
      this.isDebugMode = true;
    }
    else {
      this.isDebugMode = false;
    }
  }

  log (...args:any) {
    if (this.isDebugMode) {
      console.log('%c DEBUG::', "color:white; background: #444; padding: 2px;", ...args);
    }
  }

}
